import React, { ReactElement } from 'react';

import { Loader } from '~/components/ui';

interface RemoveCartButtonProps {
  isApplied: boolean;
  isLoading: boolean;
  onClick: (applyState: boolean) => void;
}

export default React.memo(function Credits({
  isApplied,
  isLoading,
  onClick,
}: Readonly<RemoveCartButtonProps>): ReactElement {
  if (!isApplied) return <></>;

  return (
    <button
      data-testid="unapply-btn"
      type="button"
      className="mx-auto mt-2 flex text-center text-sm text-bolt hover:underline md:mr-0 md:mt-0"
      disabled={isLoading}
      onClick={() => onClick(false)}
    >
      <p className="float-left">Remove from cart</p>
      {isLoading && isApplied && <Loader className="ml-2" size="sm" />}
    </button>
  );
});
